module.exports = __webpack_public_path__ + "static/media/activity-pdf.d83213ab.png";